export default __webpack_public_path__ + "static/linkedin-icon-62f53830c2372fb97bbcbc59c9c569c1.svg";